import { helper } from '@ember/component/helper';

import { colorForCategory } from '../utils/style-utils';

export function categoryColor([status]: [string]) {
  return colorForCategory(status);
}

export default helper(categoryColor);
